


















































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Types
import { IClientAuthProviderMethods } from "@/models/providers/clientAuth";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";
import { IState } from "@/store";
import { GuestRoutes } from "@/data/enums/router";

@Component({
  components: {
    "client-auth-provider": () =>
      import("@/components/app/global/auth/clientAuth/clientAuthProvider.vue"),
    "client-auth-login-fields": () =>
      import(
        "@/components/app/global/auth/clientAuth/clientAuthLoginFields.vue"
      ),
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      )
  }
})
export default class ClientLoginForm extends Mixins(HasValidation) {
  // Data

  public isProcessing = false;
  public forgottenPasswordRouteName = GuestRoutes.FORGOTTEN_PASSWORD;

  // Computed

  public get clientTemplateProps() {
    return {
      code: ClientTemplateSlotCodes.LOGIN_PAGE,
      objectId: (this.$store.state as IState).brand?.id,
      withAccessToken: false
    };
  }

  // Methods

  public async validateBeforeSubmit(
    clientAuthMethods: IClientAuthProviderMethods
  ) {
    try {
      this.isProcessing = true;
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      const { isRedirecting } = await clientAuthMethods.login();
      if (isRedirecting) this.isProcessing = false;
    } catch (error) {
      this.isProcessing = false;
      if (error === "cancelled") return;
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }
}
